import * as React from 'react';
import { AvailabilityTypes, discountFormat, IPriceString } from '../../helpers/priceHelpers';
import { __ } from '../../helpers/TranslationService';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import { ISoldOutBooking } from '../../interfaces';
export interface IPerPersonPriceOverview {
    price: IPriceString;
    dualCurrencyPrice: IPriceString;
    isDualCurrency?: boolean;
    discount: number;
    discountThreshold?: number;
    withFlight: boolean;
    hasHotelServiceCharges: boolean;
    soldOutBooking?: ISoldOutBooking;
}
const t_upTo = __('up to', 'dreamlines');
const t_pricePerPerson = __('pricePerPerson', 'dreamlines');
const t_incHotelServices = __('incl. hotel service charges', 'dreamlines');
const t_incFlight = __('including flight', 'dreamlines');

const PerPersonPriceOverview = (props: IPerPersonPriceOverview) => {
    const {
        price,
        dualCurrencyPrice,
        isDualCurrency = false,
        discount,
        discountThreshold,
        withFlight = false,
        hasHotelServiceCharges = false,
        soldOutBooking,
    } = props;

    const t_onRequest = __(
        soldOutBooking?.funnelType
            ? AvailabilityTypes[soldOutBooking.funnelType]
            : AvailabilityTypes['onRequest'],
        'dreamlines',
    );

    if (!price.string || !price.valid) {
        return (
            <div className="per-person-price-overview" data-testid="on-request">
                <span className="per-person-price-overview__price">{t_onRequest}</span>
            </div>
        );
    }

    const principalPrice = isDualCurrency ? dualCurrencyPrice.string : price.string;
    const hasDiscount = discountThreshold ? discount >= discountThreshold : discount > 0;

    return (
        <div className="per-person-price-overview">
            {hasDiscount && (
                <div className="per-person-price-overview__discount" data-testid="discount-tag">
                    <span className="per-person-price-overview__discount__label">{t_upTo}</span>
                    <span className="per-person-price-overview__discount__value">
                        {discountFormat(discount)}
                    </span>
                </div>
            )}
            <div className="per-person-price-overview__price-block">
                <span className="per-person-price-overview__title">{t_pricePerPerson}</span>

                <div className="per-person-price-overview__price-holder">
                    <span className="per-person-price-overview__price" data-testid="price">
                        {principalPrice}
                    </span>
                </div>

                {isDualCurrency && (
                    <span
                        className="per-person-price-overview__dual-price"
                        data-testid="dual-price"
                    >
                        {price.string}
                    </span>
                )}

                {hasHotelServiceCharges && (
                    <span
                        className="per-person-price-overview__hotel-services"
                        data-testid="hotel-service"
                    >
                        {t_incHotelServices}
                    </span>
                )}

                {withFlight && (
                    <span
                        className="per-person-price-overview__including-flight"
                        data-testid="including-flight"
                    >
                        {t_incFlight}
                    </span>
                )}
            </div>
        </div>
    );
};

export default PerPersonPriceOverview;
